import type { EditorPlugin } from '../../types';
import { getDecorate } from './decorate';
import { INSERTION_MARK_ID } from './types';

/**
 * Inert until an insertion registers an anchor ref: `decorate` returns an empty array on
 * its first line while the registry is empty.
 */
export function InsertionMarkPlugin(): EditorPlugin {
  return {
    pluginID: INSERTION_MARK_ID,
    decorate: getDecorate(),
  };
}
